import React from 'react';

import {TextMain, ViewLine} from './layout/PDFLayout';
import {BaselinePDFPhaseType} from './BaselinePDFTypes';

type BaselinePDFSummaryPhaseProps = {
	phase: BaselinePDFPhaseType;
};
const BaselinePDFSummaryPhase = ({phase}: BaselinePDFSummaryPhaseProps): JSX.Element => {
	return (
		<ViewLine>
			<TextMain style={{width: '80%'}}>{phase.name}</TextMain>
			<TextMain bold style={{textAlign: 'right', width: '20%'}}>
				{phase.total}
			</TextMain>
		</ViewLine>
	);
};

export default BaselinePDFSummaryPhase;
